import { useState } from "react";
import { Form, Input, Button, message } from "antd";
import { contactFormAPI } from "../services/api";

export default function ContactForm() {
  const [form] = Form.useForm();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();

  const handleFormSubmit = async (values) => {
    try {
      setIsSubmitting(true);
      
      const response = await contactFormAPI.submit({
        firstname: values.firstname,
        lastname: values.lastname || null,
        email: values.email,
        subject: values.subject || null,
        requirement: values.requirement || null
      });

      if (response.data.success) {
        messageApi.success(response.data.message || "Thanks for reaching out! Our team will get back to you shortly.");
        form.resetFields();
      } else {
        throw new Error(response.data.message || "Failed to submit form");
      }
    } catch (error) {
      console.error("Contact form submission error:", error);
      const errorMessage = error.response?.data?.message || error.message || "Something went wrong. Please try again.";
      messageApi.error(errorMessage);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      {contextHolder}
      <section className="get-in-touch-section py-24 px-4" style={{ background: '#f8f9fa' }}>
        <div className="container">
          <div className="row align-items-center g-5">
            <div className="col-12 col-lg-6 mb-5 mb-lg-0">
              <h2 className="get-in-touch-title">Get In Touch</h2>
              <p className="get-in-touch-description">
                If you need more information or have any inquiries, don't hesitate to reach out! Our committed team is ready to assist you with prompt and thorough responses.
              </p>
              <div className="get-in-touch-illustration">
                <img src="/images/contactimg2.jpg" alt="Contact Us" className="img-fluid" />
              </div>
            </div>
            <div className="col-12 col-lg-6">
              <Form
                form={form}
                layout="vertical"
                onFinish={handleFormSubmit}
                className="contact-form-main"
              >
                <div className="row">
                  <div className="col-12 col-md-6">
                    <Form.Item
                      name="firstname"
                      label="Firstname"
                      rules={[{ required: true, message: "Please enter your first name" }]}
                    >
                      <Input size="large" placeholder="Firstname *" className="contact-form-input" />
                    </Form.Item>
                  </div>
                  <div className="col-12 col-md-6">
                    <Form.Item name="lastname" label="Lastname">
                      <Input size="large" placeholder="Lastname" className="contact-form-input" />
                    </Form.Item>
                  </div>
                </div>
                <Form.Item
                  name="email"
                  label="Email"
                  rules={[
                    { required: true, message: "Please enter your email" },
                    { type: "email", message: "Please enter a valid email" },
                  ]}
                >
                  <Input size="large" placeholder="Email *" className="contact-form-input" />
                </Form.Item>
                <Form.Item name="subject" label="Subject">
                  <Input size="large" placeholder="Subject" className="contact-form-input" />
                </Form.Item>
                <Form.Item name="requirement" label="Describe your requirement">
                  <Input.TextArea
                    rows={6}
                    placeholder="Describe your requirement"
                    className="contact-form-textarea"
                  />
                </Form.Item>
                <Form.Item>
                  <Button
                    type="primary"
                    size="large"
                    htmlType="submit"
                    className="contact-form-submit"
                    loading={isSubmitting}
                  >
                    Submit
                  </Button>
                </Form.Item>
              </Form>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
